import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";

export const requestDeleteMarketingFlow = async (
  flowId: string
): Promise<{ ok: boolean }> => {
  return await instance.delete(`${ApiRoutesMarketing.Flows}/${flowId}`);
};
